import type { FaireProductEntity } from "../../entity_types/product";

export const p_5t6xu2g478: FaireProductEntity = {
  token: "p_5t6xu2g478",
  type: "product",
  name: "2-Piece Crop Tee & Wide Leg Lounge Pants Set",
  brandToken: "b_1f7p8ul7e0",
  brandName: "CAPELLA APPAREL",
  imageUrl:
    "https://cdn.faire.com/fastly/62102aea2e5fc94143ba4cccc38b8eabf1e79afcfdd1620ddfd237032bfe978b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9202eac8756db529b1ebe424d53ea576e46dfd3449af1720307c54e02be20469.jpeg",
    "https://cdn.faire.com/fastly/0f0e84384798e366171b27290ce9ff68d9f6fb33a3bf6a2a2c7cf08aae1a77dd.jpeg",
    "https://cdn.faire.com/fastly/4a0cee1794ef536f30219386065bc42ff306cc9f31bcc20534c5e0f450460a09.jpeg",
    "https://cdn.faire.com/fastly/17d8da1584ef05cb24d8f8521502c1ec3b60977e0d9884cf53aa42497c3b3266.jpeg",
    "https://cdn.faire.com/fastly/6a694aa6a6717ea6c066bd8e472a4f968591bb7afbd3c5eb39080c92cda143c7.jpeg",
    "https://cdn.faire.com/fastly/7b3546dc785ce97928a78cd9d65384532c1bbec1214a14f138b00b9ea10aaaa9.jpeg",
    "https://cdn.faire.com/fastly/f1a9d62e07b69e9919ffff7a119fe8b8d60167e5e025ace8e7159ff01402df32.jpeg",
    "https://cdn.faire.com/fastly/668f06bd195d5b885d8d278d97827a165edd2865bffdfd74e3c5e376b297ad44.jpeg",
    "https://cdn.faire.com/fastly/4f8a85e6277c0734472a35849f560ea9a47a7eb19c02d21a3e93c595f0e15dfd.jpeg",
    "https://cdn.faire.com/fastly/aad9a49580bc37bd7466c29c3a86ccd47e38773245f9f39a54f8492585cb77af.jpeg",
    "https://cdn.faire.com/fastly/591a24feb3a76790306db6d60fa583c265fa7ea91125d72a1194dd0e9057637a.jpeg",
    "https://cdn.faire.com/fastly/601a3558dfc89ae8f7176ea47f444c22f0fc56dbb2df65295e2996dbe90ec66d.jpeg",
    "https://cdn.faire.com/fastly/e309a0221c0d977f07af81af480132e28ca5e19fd0e5c3990c3f4380f7bfc2de.jpeg",
    "https://cdn.faire.com/fastly/b5c3a6952215e3a9d99df3cbbe3338a29db0cd5ccfbc0b62a5b311096d9dd214.jpeg",
    "https://cdn.faire.com/fastly/9e4c92e893bfc2a432a20b87e84ee0d5af2d7cf8f3c65972f4195005d3fd8dbf.jpeg",
    "https://cdn.faire.com/fastly/10294e210c63110274f9e9132f90da424ef8b9a686a1716a5c29a53ebde5d990.jpeg",
    "https://cdn.faire.com/fastly/901713250bd34d2f897fcfad0a60ff3f0582e4c732199c67c085eb598e058034.jpeg",
    "https://cdn.faire.com/fastly/7d314885b79d7be9d06de118277aab9ab7937fc7191005eab884dece5c3a9c0d.jpeg",
    "https://cdn.faire.com/fastly/db754e152285a9cbf842fe2df53a0563ba4efa419893395264cdcc99e5716288.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "Style # BTP5606\n\nThis two-piece set is your go-to for comfy style with a clean, modern vibe. The fitted crop tee pairs effortlessly with the wide leg lounge pants, creating an easy, flattering silhouette. The pants feature a stretchy waistband and a faux drawstring for a chill, pulled-together look—no adjusting needed. Whether you're lounging at home or stepping out in sneakers, this set delivers casual confidence all day.\n\n-2-piece set: fitted short sleeve crop top + wide leg pants\n-Soft, breathable knit with a smooth finish\n-Elastic waistband with faux drawstring (non-adjustable)\n-Easy pull-on design for comfort and convenience\n-Perfect for lounging, errands, or low-key outings\n\nloungewear set, wide leg pants set, crop tee set, comfy 2-piece outfit, casual lounge co-ord, athleisure set, stretch waistband pants, soft knit outfit\n\n\nModel is 5' 5\" and wearing a S.",
  tags: [],
  msrpDollars: 30.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:22.085Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
